/**
 * "Green glow and a soft chime for correct answers."
 *
 * Synthesised with the Web Audio API rather than shipped as a file. Three
 * reasons, in order of how much they matter here: it is zero bytes on a
 * connection where a 30 KB mp3 is a real cost; it works offline on the first
 * run, before anything has been cached; and it cannot be the asset somebody
 * forgot to upload.
 *
 * Silently does nothing when the browser has no audio context, or when the
 * learner has not interacted yet and autoplay policy refuses. A chime is
 * reinforcement, never information — the tick and the glow carry the message.
 */
let context = null;
function ensureContext() {
    if (typeof window === 'undefined')
        return null;
    const Ctor = window.AudioContext ?? window.webkitAudioContext;
    if (!Ctor)
        return null;
    if (!context)
        context = new Ctor();
    return context;
}
export function playChime(kind = 'correct') {
    try {
        const audio = ensureContext();
        if (!audio)
            return;
        if (audio.state === 'suspended')
            void audio.resume();
        const now = audio.currentTime;
        // A rising major third for correct, a single low tone for incorrect. Not a
        // buzzer: a Grade 7 learner getting a question wrong does not need to be
        // startled, they need to try again.
        const notes = kind === 'correct' ? [659.25, 830.61] : [220];
        notes.forEach((frequency, index) => {
            const oscillator = audio.createOscillator();
            const gain = audio.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.value = frequency;
            const start = now + index * 0.09;
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(0.12, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28);
            oscillator.connect(gain).connect(audio.destination);
            oscillator.start(start);
            oscillator.stop(start + 0.3);
        });
    }
    catch {
        // Audio is decoration. A browser that refuses it changes nothing about the
        // lab, so this never surfaces an error.
    }
}
//# sourceMappingURL=chime.js.map